import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  NotifyCohortDto,
  NotifyCohortResponseDto,
} from '../../../models/user-cohort/dto/user-cohort.dto';

export function useNotifyCohort(cohortId: string) {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (dto: NotifyCohortDto) => {
      const response = await apiClient.fetchApi<
        NotifyCohortResponseDto,
        NotifyCohortDto
      >({
        method: 'POST',
        endpoint: `cohorts/${cohortId}/notify`,
        body: dto,
      });
      return response;
    },
  });
}
